import { Center, Spinner, VStack } from '@chakra-ui/react';

import Text from 'components/Text';

/**
 * Loading state for the CV editor.
 * Shows a centered spinner with text while CV data loads.
 */
const CVEditorSkeleton = () => (
  <Center
    height="calc(100vh - 60px)"
    mx={-4}
    mt={-4}
    width="calc(100% + 32px)"
    maxWidth="calc(100% + 32px)"
  >
    <VStack spacing={4}>
      <Spinner size="lg" color="purple.300" />
      <Text fontSize="small" opacity="secondary">
        Loading CV data...
      </Text>
    </VStack>
  </Center>
);

export default CVEditorSkeleton;
